import React from "react";
import profil from "../../../assets/images/profil.png";
import "./About.css";

const About = ({ reff }) => {
  return (
    <section
      ref={reff}
      id="about"
      className="py-5"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="container">
        <h2 className="h1-responsive font-weight-bold text-center mb-5">
          About Me
        </h2>

        <div className="row">
          <div className="col-12 col-lg-4">
            <img className="d-block mx-auto mb-4" src={profil} alt="profil" />
          </div>
          <div className="col-lg-8">
            <p className="text-font text-justify">
              As a recent Information Technology graduate from SLIIT, I am passionate about leveraging cutting-edge technologies to create innovative solutions that make a real difference. My academic journey and professional experience have equipped me with a robust foundation in software engineering, specializing in both Java Spring Boot and MERN stack development.
              <br /><br />
              In the Java ecosystem, I have extensive experience with Spring Boot, Spring Security, and Spring Data JPA. I excel in developing enterprise-level applications using Spring Framework's core features including Dependency Injection, AOP, and Transaction Management. My expertise extends to implementing RESTful APIs with OAuth2 authentication, JPA/Hibernate for database operations, and integration with various databases including MySQL and PostgreSQL.
              <br /><br />
              Additionally, I specialize in full-stack development using the MERN stack (MongoDB, Express.js, React.js, Node.js), with hands-on experience in cloud platforms like AWS and Azure. My technical expertise extends to DevOps practices, including Docker containerization and CI/CD pipelines, ensuring smooth deployment and maintenance of applications in production environments.
              <br /><br />
              Throughout my academic journey and professional experience, I have successfully delivered multiple projects that demonstrate my ability to transform complex requirements into elegant, user-centric solutions using both Spring Boot and MERN stack technologies. I am particularly skilled in microservices architecture, API development, and implementing robust security measures.
              <br /><br />
              Beyond technical skills, I bring strong leadership abilities and a commitment to writing clean, maintainable code. I stay current with industry trends and best practices in both Java and JavaScript ecosystems, constantly expanding my knowledge through continuous learning and practical application.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
